// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getRgaSubtypes} from '../../shared/repositories';
import {readOpenPartRequests} from './open-part-requests';

export const getRequestTypes = () =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const allowedTypes = await getRgaSubtypes();

            dispatch({
                allowedTypes,
                type: actions.UPDATE_OPEN_PART_REQUESTS_ALLOWED_REQUEST_TYPES
            });

            if (getState().partReturns.openPartReturns.facets.dealerAccountsFacet.isInitialLoad) {

                dispatch({
                    requestTypes: allowedTypes,
                    type: actions.UPDATE_OPEN_PART_REQUESTS_SELECTED_REQUEST_TYPES
                });

                dispatch({
                    type: actions.UPDATE_OPEN_PART_REQUESTS_IS_INITIAL_LOAD
                });

            }

            readOpenPartRequests()(dispatch, getState);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const resetAllFacets = (defaultDealerAccounts, allowedRequestTypes) => ({
    allowedRequestTypes,
    defaultDealerAccounts,
    type: actions.RESET_OPEN_PART_REQUESTS_FILTERS
});

export const selectAllDealersOnInitialLoad = allowedDealers => ({
    allowedDealers,
    type: actions.SELECT_ALL_OPEN_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEMS
});

export const toggleDealerAccountFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_OPEN_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEMS
});

export const updateDealerAccountFacetInput = value => ({
    type: actions.UPDATE_OPEN_PART_REQUESTS_DEALER_ACCOUNT_FACET_INPUT,
    value
});

export const updateDealerAccountFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_OPEN_PART_REQUESTS_DEALER_ACCOUNT_FACET_ITEM
});

export const updateOpenPartRequestsDateRangeFacet = dateRange => ({
    dateRange,
    type: actions.UPDATE_OPEN_PART_REQUESTS_REQUEST_DATE_RANGE_FACET
});

export const updateSelectedPartRequestType = (requestType, isSelected) => ({
    isSelected,
    requestType,
    type: actions.UPDATE_OPEN_PART_REQUESTS_SELECTED_REQUEST_TYPE
});



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/action-creators/facets.js